export default __webpack_public_path__ + "static/media/Йод_20л.6e7a2462.jpg";